import React from 'react';
import senerfiBlanco from '../../assets/images/senerfiblanco.png';

export function Header({ rightSlot, onBrandClick }) {
  return (
    <div className="w-full shadow-md" style={{ backgroundColor: '#F07E2D' }}>
      <div className="max-w-6xl mx-auto flex items-center justify-between h-14 px-4">
        <img src={senerfiBlanco} alt="Senerfi" className="h-8 w-auto cursor-pointer" onClick={onBrandClick} />
        <div>{rightSlot}</div>
      </div>
    </div>
  );
}
